import analyticsService from './analyticsService';
import ajaxLocalStorageService from './ajaxLocalStorageService';
import anthroCookieService from './anthroCookieService';
import cartService from './cartService';
import categoryHTTPService from './categoryHTTPService';
import checkoutHTTPService from './checkoutHTTPService';
import configHTTPService from './configHTTPService';
import customerSubscription from './customerSubscription';
import dateService from './dateService';
import emailHTTPService from './emailHTTPService';
import i18nService from './i18nService';
import interceptorService from './interceptorService';
import localStorageService from './localStorageService';
import mediaUrlService from './mediaUrlService';
import MISLHTTPService from './MISLHTTPService';
import ordersHTTPService from './ordersHTTPService';
import productHTTPService from './productHTTPService';
import profileHTTPService from './profileHTTPService';
import profileService from './profileService';
import responsiveService from './responsiveService';
import rootCatsHTTPService from './rootCatsHTTPService';
import rootCatsService from './rootCatsService';
import routerService from './routerService';
import reduxService from './reduxService';
import scrollService from './scrollService';
import suggestiveSearchService from './suggestiveSearchService';
import translationService from './translationService';
import errorHandlerService from './errorHandlerService';

export const LegacyServices = angular.module('legacy.services', [])
    .factory('AnalyticsService', analyticsService)
    .factory('AjaxLocalStorageService', ajaxLocalStorageService)
    .factory('AnthroCookieService', anthroCookieService)
    .factory('CartService', cartService)
    .factory('CategoryHTTPService', categoryHTTPService)
    .factory('CheckoutHTTPService', checkoutHTTPService)
    .factory('ConfigHTTPService', configHTTPService)
    .factory('CustomerSubscription', customerSubscription)
    .factory('DateService', dateService)
    .factory('EmailHTTPService', emailHTTPService)
    .factory('I18nService', i18nService)
    .factory('InterceptorService', interceptorService)
    .factory('LocalStorageService', localStorageService)
    .factory('MediaUrlService', mediaUrlService)
    .factory('MISLHTTPService', MISLHTTPService)
    .factory('OrdersHTTPService', ordersHTTPService)
    .factory('ProductHTTPService', productHTTPService)
    .factory('ProfileHTTPService', profileHTTPService)
    .factory('ProfileService', profileService)
    .factory('ResponsiveService', responsiveService)
    .factory('RootCatsHTTPService', rootCatsHTTPService)
    .factory('RootCatsService', rootCatsService)
    .factory('RouterService', routerService)
    .factory('ReduxService', reduxService)
    .factory('ScrollService', scrollService)
    .factory('SuggestiveSearchService', suggestiveSearchService)
    .factory('TranslationService', translationService)
    .factory('ErrorHandler', errorHandlerService);

export default LegacyServices;
